import URLConfig from '@Config/urls/url.config';
import React from "react";
import { Route } from "react-router-dom";
import * as CardHolderModule from '@Modules/cardManagementSystem/cardholder/pages';
import cardHolderRoutes from './cardholder/CardHolderRoutes';
import * as PrepaidModule from '@Modules/cardManagementSystem/prepaid/pages';
import PrepaidRoutes from './prepaid/PrepaidRoutes';
import SmartRoutes from './smart/SmartRoutes';
import * as DebitModule from '@Modules/cardManagementSystem/debit/pages';
import debitHolderRoutes from './debit/DebitRoutes';

const CardManagementSystemRoutes = [
  // Card Holder Routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.ROOT}
    element={<CardHolderModule.CardHolderLayout />}
  >
    {cardHolderRoutes.map((chroute, index) => React.cloneElement(chroute, { key: index}))}
  </Route>,

  // Debit Routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.ROOT}
    element={<DebitModule.DebitLayout />}
  >
    {debitHolderRoutes.map((dbroute, index) => React.cloneElement(dbroute, { key: index}))}
  </Route>,

  // Prepaid Routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.ROOT}
    element={<PrepaidModule.PrepaidLayout />}
  >
    {PrepaidRoutes.map((chroute, index) => React.cloneElement(chroute, { key: index}))}
  </Route>,

  // Smart Routes
  <Route
    path={URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.ROOT}
    element={<PrepaidModule.PrepaidLayout />}
  >
    {SmartRoutes.map((chroute, index) => React.cloneElement(chroute, { key: index}))}
  </Route>,
];

export default CardManagementSystemRoutes;
